import React from 'react';
import config from 'init/config';
import SiteSearchAPIConnector from '@elastic/search-ui-site-search-connector';
import { SearchProvider } from '@elastic/react-search-ui';

const connector = new SiteSearchAPIConnector({
  documentType: 'page',
  engineKey: config.swiftypeConfig.engine_key
});

const filters = [
  {
    field: 'content_type',
    values: ['Help Article'],
    type: 'all'
  }
];

const HelpSearchProvider = ({ children, history, location }) => (
  <SearchProvider
    config={{
      apiConnector: connector,
      resultsPerPage: 15,
      autocompleteQuery: {
        results: {
          filters: filters
        }
      },
      initialState: {
        filters: filters
      }
    }}
  >
    {children}
  </SearchProvider>
);

export default HelpSearchProvider;
